import { getWindowObject } from '@eventbrite/feature-detection';
import { RatingData } from './types';

export const getClampedValue = (value: number): number => {
    return value > 100 ? 100 : value < 0 ? 0 : value;
};

export const getPercentage = (value: number, total: number): number => {
    return (value * 100) / total;
};

export const getLocaleInfo = (): string => {
    return (
        getWindowObject('__SERVER_DATA__')?.env?.localeInfo?.locale || 'en_US'
    );
};

export const getSortedRatingCounts = (ratingData: RatingData) => {
    const {
        total_count: { value: totalCount, display: displayCount },
        rating,
        break_down: breakDown,
    } = ratingData;
    const ratingCounts = breakDown.sort(
        (a, b) => b.rating_star - a.rating_star,
    );
    return { ratingCounts, totalCount, displayCount, rating };
};

export const getDomain = () => {
    return getWindowObject('__SERVER_DATA__')?.env?.ebDomain;
};
